export default __webpack_public_path__ + "static/media/mobileWef1Full.38360b58.png";